import * as Yup from 'yup';

const zoneSchema = Yup.object({
  ZoneCode: Yup.string().trim().required('Zone Code is required'),
  AgencyID: Yup.string().nullable().required('Agency is required'),
});
export default zoneSchema;
